/** Import modules */

import { useTranslation }           from "react-i18next";

import { useParams, useNavigate }   from "react-router-dom";

/** Import hooks */

import { TyresNavigator }           from "../../../../../Hooks/TyresNavigator";

/** Import datasets */

import { SizeFilters }              from "../../../../../Datasets/Tyres";

/** Import components */

import SearchableSelect             from "../../../../Shared/SearchableSelect";

/** Import icons */

import { AiFillInfoCircle }         from "react-icons/ai";

/**
 * 
 * @param { attributes } param0 
 * 
 * @returns Tyre size filter component
 * 
 */

const Size = ( { attributes } ) => { const 
    
    { t }               = useTranslation    (),

    navigate            = useNavigate       (),

    { parameters }      = useParams         (),

    Filter = ( value, id ) => { const 

        object = { f : 12, l: null, a: null, b: null, loc: window.pageYOffset };

        if ( id === "w" ) object.w = ( value === "default" ) ? null : value;

        if ( id === "h" ) object.h = ( value === "default" ) ? null : value;

        if ( id === "d" ) object.d = ( value === "default" ) ? null : value;

        return navigate (  
            
            `/shop/tyres/${
            
                new URLSearchParams ( TyresNavigator ( parameters, object ) ).toString () }` );

    };

    /** Return component */

    return ( <div className="content sizes">

        { SizeFilters ( attributes ).map ( ( size, index ) => <div className="select-filter" key={ index }>

            <div className="title">

                <div className="name">
                    
                    { size.name }
                    
                </div>

                <div className="info">

                    <span className="filter-tooltip">
                        
                        { size.tooltip }
                        
                    </span>

                    <AiFillInfoCircle />

                </div>

            </div>

            <div className="select shadow-select">

                <SearchableSelect
                    options={ size.options }
                    value={ new URLSearchParams ( parameters ).get ( size.id ) || "default" }
                    onChange={ value => Filter ( value, size.id ) }
                    type={ size.type === "STRING" ? "TEXT" : size.type }
                    label={ t ( "select_option" ) }
                />

            </div>

        </div> ) }

    </div> );

}

/** Export component */
 
export default Size;